import React, { useState, useEffect, useRef, useMemo } from 'react';
import axiosInstance from '../../utils/axiosInstance';
import { useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditBlog = () => {
   const id = useParams().id;
   useEffect(()=>{
    console.log("Id", id)
   },[])
    // const [libsLoaded, setLibsLoaded] = useState(!!window.ReactQuill);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState('');
    const quillRef = useRef(null);

    const [currentImageUrl, setCurrentImageUrl] = useState(null);
    const [currentPdfUrl, setCurrentPdfUrl] = useState(null);

    const [isVideo, setIsVideo] = useState(false);
    const [isForm, setIsForm] = useState(false);
    const [videoLink, setVideoLink] = useState('');
    const [paymentLink, setPaymentLink] = useState('');
    const [linkName, setLinkName] = useState('');
    const [link, setLink] = useState('');

    const inputStyles = "bg-gray-900 border border-gray-700 text-gray-200 p-3 rounded-lg w-full focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all duration-300 shadow-sm";
    const labelStyles = "block text-gray-300 text-sm font-semibold mb-2";



      useEffect(() => {
        axiosInstance.get('/categories')
            .then(res => setCategories(res.data))
            .catch(err => console.error("Failed to fetch categories", err));
    }, []);

    // Fetch blog data to edit
    useEffect(() => {
        if (!id) {
            setStatus("Blog ID not found in URL.");
            return;
        };
        
        setIsLoading(true);
        axiosInstance.get(`/blogs/${id}`)
            .then(resp => {
              const blog = resp.data;
                setTitle(blog.title);
                setContent(blog.content);
                setSelectedCategory(blog.category_id);
                setIsVideo(blog.isVideo == '1'); // Handle boolean conversion from string
                setVideoLink(blog.video_link || '');
                setPaymentLink(blog.pay_link || '');
                setIsForm(!!blog.form_link);
                setLinkName(blog.form_name || '');
                setLink(blog.form_link || '');
                setCurrentImageUrl(blog.image);
                setCurrentPdfUrl(blog.pdf_drive_link);
            })
            .catch(err => {
                console.error("Failed to fetch blog data", err);
                setStatus('Failed to load blog data.');
            })
            .finally(() => setIsLoading(false));
    }, [id]);

    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            const formData = new FormData();
            formData.append('image', file);
            try {
                const response = await axiosInstance.post('/blogs/upload-image-cloudinary',  formData );
                const imageUrl = response.url;
                const quill = quillRef.current.getEditor();
                const range = quill.getSelection(true);
                quill.insertEmbed(range.index, 'image', imageUrl);
            } catch (error) {
                console.error('Quill image upload failed', error);
            }
        };
    };

   const modules = useMemo(() => ({
    toolbar: {
        container: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }], // <-- Added this line for colors
            ['link']
        ],
        handlers: { image: imageHandler },
    },
}), []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        let finalImageUrl = currentImageUrl;
        let finalPdfUrl = currentPdfUrl;

        try {
         

              if (imageFile) {
                setStatus('Uploading featured image...');
                const imageFormData = new FormData();
                imageFormData.append('image', imageFile);
                const imgRes = await axiosInstance.post('/blogs/upload-image-cloudinary', imageFormData);
                finalImageUrl = imgRes.data.url;
            }

            if (pdfFile) {
                setStatus('Uploading PDF...');
                const pdfFormData = new FormData();
                pdfFormData.append('pdfFile', pdfFile);
                const pdfRes = await axiosInstance.post('/blogs/upload-pdf-local', pdfFormData);
                finalPdfUrl = pdfRes.data.link;
            }


            setStatus('Saving blog post...');
            const blogData = {
                title,
                content,
                category_id: selectedCategory,
                image: finalImageUrl,
                pdf_link: finalPdfUrl,
                isVideo: isVideo,
                video_link: isVideo ? videoLink : null,
                payment_link: paymentLink || null,
                form_name: isForm ? linkName : null,
                form_link: isForm ? link : null
            };

            // await axiosInstance.post(`/blogs/update/${id}`, blogData);
            await axiosInstance.put(`blogs/${id}`, blogData);
            // window.location.href = '/admin/blogs-manage';
                 setStatus('');
            
        } catch (error) {
            console.error('Failed to update blog:', error);
            setStatus(`Error: ${error.response?.data?.error || 'An unknown error occurred.'}`);
        } finally {
            setIsLoading(false);
        }
    };

   
    
    
    if (!id) {
        return <p className="text-center text-red-500 p-8">Error: No Blog ID found in the URL. Please check the address and try again.</p>;
    }
    
    if (isLoading && !title) {
        return <p className="text-center text-gray-300">Loading blog for editing...</p>;
    }

    return (
        <div className="max-w-6xl mx-auto p-2">
            <form onSubmit={handleSubmit} className="bg-gray-800 p-8 rounded-2xl shadow-xl space-y-6">
                <h1 className="text-4xl font-bold mb-8 text-gray-100 text-center">Edit Blog</h1>
                <div>
                    <label className={labelStyles}>Title</label>
                    <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className={inputStyles} placeholder="Enter blog title" required />
                </div>
                <div>
                    <label className={labelStyles}>Category</label>
                    <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} className={inputStyles + " bg-gray-900"} required>
                        <option value="" disabled>Select a category</option>
                        {categories.length>0 && categories.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
                    </select>
                </div>
                <div>
                    {/* <label className={labelStyles}>Content</label> */}
                    {/* <ReactQuill ref={quillRef} theme="snow" value={content} onChange={setContent} modules={modules} className="bg-gray-900 rounded-lg" /> */}
           
                </div>

                <div>
                    <label className={labelStyles}>Content</label>
                    <ReactQuill ref={quillRef} theme="snow" value={content} onChange={setContent} modules={modules} className="bg-gray-900 rounded-lg" />
                </div>
                <div>
                    <label className={labelStyles}>Featured Image (Upload new to replace)</label>
                    {currentImageUrl && !imageFile && (
                        <div className="my-2">
                            <p className="text-sm text-gray-400 mb-2">Current Image:</p>
                            <img src={currentImageUrl} alt="Current featured" className="w-32 h-32 object-cover rounded-lg" />
                        </div>
                    )}
                    <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} className={inputStyles} />
                </div>
                <div>
                    <label className={labelStyles}>Attach PDF (Upload new to replace)</label>
                     {currentPdfUrl && !pdfFile && (
                        <div className="my-2">
                            <p className="text-sm text-gray-400 mb-2">Current PDF: <a href={currentPdfUrl} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">View PDF</a></p>
                        </div>
                    )}
                    <input type="file" accept=".pdf" onChange={(e) => setPdfFile(e.target.files[0])} className={inputStyles} />
                </div>
                <div>
                    <label className={labelStyles}>Payment Link (Optional)</label>
                    <input type="url" value={paymentLink} onChange={(e) => setPaymentLink(e.target.value)} className={inputStyles} placeholder="https://example.com/payment" />
                </div>
                <div className="p-4 border border-gray-700 rounded-lg bg-gray-900">
                    <label className={labelStyles}>Is this a video post?</label>
                    <div className="flex items-center space-x-6 text-gray-200">
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isVideo" checked={isVideo === true} onChange={() => setIsVideo(true)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>Yes</span>
                        </label>
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isVideo" checked={isVideo === false} onChange={() => setIsVideo(false)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>No</span>
                        </label>
                    </div>
                </div>
                {isVideo && (
                    <div className="space-y-4 animate-fade-in">
                        <div>
                            <label className={labelStyles}>Video Link</label>
                            <input type="url" value={videoLink} onChange={(e) => setVideoLink(e.target.value)} className={inputStyles} placeholder="https://example.com/video" required={isVideo} />
                        </div>
                    </div>
                )}
                <div className="p-4 border border-gray-700 rounded-lg bg-gray-900">
                    <label className={labelStyles}>Is there a link ?</label>
                    <div className="flex items-center space-x-6 text-gray-200">
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isForm" checked={isForm === true} onChange={() => setIsForm(true)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>Yes</span>
                        </label>
                        <label className="cursor-pointer flex items-center space-x-2">
                            <input type="radio" name="isForm" checked={isForm === false} onChange={() => setIsForm(false)} className="form-radio h-5 w-5 text-blue-500 bg-gray-800 border-gray-600 focus:ring-blue-500" />
                            <span>No</span>
                        </label>
                    </div>
                </div>
                {isForm && (
                    <div className="space-y-4 animate-fade-in">
                        <div>
                            <label className={labelStyles}>Name</label>
                            <input type="text" value={linkName} onChange={(e) => setLinkName(e.target.value)} className={inputStyles} placeholder="Name " required={isForm} />
                        </div>
                        <div>
                            <label className={labelStyles}>Link</label>
                            <input type="url" value={link} onChange={(e) => setLink(e.target.value)} className={inputStyles} placeholder="https://example.com/link" required={isForm} />
                        </div>
                    </div>
                )}
                <button type="submit" disabled={isLoading} className="w-full py-3 bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-semibold rounded-xl hover:from-indigo-500 hover:to-blue-500 transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed">
                    {isLoading ? status : 'Update Blog Post'}
                </button>
                {!isLoading && status && <p className="text-center text-red-400 mt-2">{status}</p>}
            </form>

            <style>{`
                [contentEditable][data-placeholder]:empty:before {
                    content: attr(data-placeholder);
                    color: #9ca3af; 
                    pointer-events: none;
                    display: block; 
                }
                @keyframes fade-in {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fade-in {
                    animation: fade-in 0.5s ease-out forwards;
                }
            `}</style>
        </div>
    );
};

export default EditBlog;

